/* Café Home — scripts do tema */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2).split('.');
    var reais = value[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var str = reais + ',' + value[1];
    if (format && format.indexOf('{{') > -1) {
      return format.replace(/\{\{\s*\w+\s*\}\}/, str);
    }
    return 'R$ ' + str;
  }

  // Seletor de variantes do produto (pode haver mais de um formulário: topo e final da descrição)
  document.querySelectorAll('[data-product-form]').forEach(function (root) {
    var dataEl = root.querySelector('[data-product-json]');
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var moneyFormat = root.getAttribute('data-money-format');
    var installments = parseInt(root.getAttribute('data-installments-count') || '0', 10);
    var forms = Array.prototype.slice.call(root.querySelectorAll('[data-buy-form]'));
    var current = (product.variants.find(function (v) {
      var input = root.querySelector('[data-buy-form] input[name="id"]');
      return input && String(v.id) === input.value;
    }) || product.variants[0]).options.slice();

    function all(sel) { return root.querySelectorAll(sel); }

    function syncRadios() {
      forms.forEach(function (form) {
        form.querySelectorAll('[data-option]').forEach(function (fs) {
          var i = parseInt(fs.getAttribute('data-option-index'), 10);
          fs.querySelectorAll('input[type="radio"]').forEach(function (r) { r.checked = r.value === current[i]; });
          var label = fs.querySelector('[data-option-value]');
          if (label) label.textContent = current[i] || '';
        });
      });
    }

    function update() {
      syncRadios();
      var variant = product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === current[i]; });
      });
      all('[data-add]').forEach(function (btn) {
        if (!variant) { btn.disabled = true; btn.textContent = 'Indisponível'; return; }
        btn.disabled = !variant.available;
        btn.textContent = variant.available ? btn.getAttribute('data-label-add') : btn.getAttribute('data-label-sold');
      });
      if (!variant) return;
      all('[data-buy-form] input[name="id"]').forEach(function (input) { input.value = variant.id; });
      all('[data-price]').forEach(function (el) { el.textContent = formatMoney(variant.price, moneyFormat); });
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      all('[data-compare]').forEach(function (el) {
        el.hidden = !onSale;
        if (onSale) el.textContent = formatMoney(variant.compare_at_price, moneyFormat);
      });
      all('[data-save]').forEach(function (el) {
        el.hidden = !onSale;
        if (onSale) el.textContent = 'Você economiza ' + formatMoney(variant.compare_at_price - variant.price, moneyFormat);
      });
      if (installments > 1) {
        all('[data-installments]').forEach(function (el) {
          el.textContent = 'ou ' + installments + 'x de ' + formatMoney(Math.round(variant.price / installments), moneyFormat) + ' sem juros';
        });
      }
      if (variant.featured_media) {
        var thumb = document.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
        if (thumb) thumb.click();
      }
      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    root.addEventListener('change', function (e) {
      var fs = e.target.closest('[data-option]');
      if (!fs || e.target.type !== 'radio') return;
      current[parseInt(fs.getAttribute('data-option-index'), 10)] = e.target.value;
      update();
    });
  });

  // Galeria
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('.product__main-media img');
    if (!main) return;
    gallery.querySelectorAll('[data-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        main.src = btn.getAttribute('data-src');
        main.srcset = btn.getAttribute('data-srcset') || '';
        main.sizes = '(min-width: 990px) 55vw, 100vw';
        main.alt = btn.getAttribute('data-alt') || '';
        gallery.querySelectorAll('[data-thumb]').forEach(function (b) { b.setAttribute('aria-current', 'false'); });
        btn.setAttribute('aria-current', 'true');
      });
    });
  });

  // Quantidade
  document.querySelectorAll('[data-quantity]').forEach(function (q) {
    var input = q.querySelector('input');
    q.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var step = b.getAttribute('data-step') === 'up' ? 1 : -1;
        var min = parseInt(input.min || '0', 10);
        input.value = Math.max(min, (parseInt(input.value, 10) || 0) + step);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  // Ordenação da coleção
  var sort = document.querySelector('[data-sort]');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      window.location.href = url.toString();
    });
  }

  // Menu lateral (☰): fechar pelo X, pelo fundo, pelo Esc e ao clicar num link
  document.querySelectorAll('[data-menu-drawer]').forEach(function (d) {
    function close() { d.removeAttribute('open'); document.documentElement.style.overflow = ''; }
    d.addEventListener('toggle', function () { document.documentElement.style.overflow = d.open ? 'hidden' : ''; });
    d.querySelectorAll('[data-menu-close]').forEach(function (b) { b.addEventListener('click', close); });
    d.querySelectorAll('.menu-drawer__panel a').forEach(function (a) { a.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && d.open) close(); });
  });

  // Carrossel de avaliações
  document.querySelectorAll('[data-reviews]').forEach(function (root) {
    var track = root.querySelector('[data-reviews-track]');
    var prev = root.querySelector('[data-reviews-prev]');
    var next = root.querySelector('[data-reviews-next]');
    if (!track || !prev || !next) return;
    function step() {
      var item = track.querySelector('.reviews__item');
      if (!item) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return item.getBoundingClientRect().width + gap;
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });
})();
